import * as application from './application';
import * as enterprise from './enterprise';
import * as integrations from './integrations';
import * as urls from './urls';

export * from './application';
export * from './enterprise';
export * from './integrations';
export * from './urls';

const Default = {
  ...application,
  ...enterprise,
  ...integrations,
  ...urls,
};

export type PageKeys =
  | 'home'
  | 'login'
  | 'logout'
  | 'job'
  | 'quote'
  | 'reapply'
  | 'payByCard'
  | 'payByBank'
  | 'applyForFinance'
  | 'applyForFinanceWelcome'
  | 'applyForFinanceTermsAndConditions'
  | 'applyForFinanceDetails'
  | 'continueApplication'
  | 'status'
  | 'paymentSuccess'
  | 'authLink'
  | 'staffLogin'
  | 'staff'
  | 'expired'
  | 'applyWelcome'
  | 'applyDetails'
  | 'applyAddress'
  | 'applyEmployment'
  | 'applySuccess'
  | 'applyMoreInfo'
  | 'applyReferred'
  | 'customCode'
  | 'consentSuccess'
  | 'completeIntroduction';

export const URLS: Record<PageKeys, string> = {
  home: '/',
  login: '/login',
  logout: '/logout',
  job: '/job/:id?',
  quote: '/quote/:id?',
  reapply: '/reapply/:id?',
  payByCard: '/pay-by-card/:id?',
  payByBank: '/pay-by-bank/:id?',
  applyForFinance: '/apply-for-finance/:id?',
  applyForFinanceWelcome: '/apply-for-finance/welcome/:id?',
  applyForFinanceTermsAndConditions:
    '/apply-for-finance/terms-and-conditions/:id?',
  applyForFinanceDetails: '/apply-for-finance/details/:id?',
  continueApplication: '/continue-application/:id?',
  status: '/status/:id?',
  paymentSuccess: '/success/:id?',
  authLink: '/auth-link',
  staffLogin: '/staff-login',
  staff: '/staff',
  expired: '/expired',
  applyWelcome: '/start-application/welcome/:id',
  applyDetails: '/start-application/details/:id',
  applyAddress: '/start-application/address/:id',
  applyEmployment: '/start-application/employment/:id',
  applySuccess: '/start-application/success/:id',
  applyMoreInfo: '/start-application/more-info/:id',
  applyReferred: '/start-application/referred/:id',
  customCode: '/custom-code',
  consentSuccess: '/consent-success',
  completeIntroduction: '/complete-introduction/:id?',
};

export default Default;
